/**
 * @author Ariel
 * @description 共建店管理
 * @Date 2020/1/10
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";
import {component_tool,framework_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport} = component_tool

class DealerUnionManager extends WizContainer {
  componentName = 'dealerUnionManager';

  constructor(props) {
    super(props);
    this.state={
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '共建类型',
        field: 'dealerUnionType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '共建状态',
        field: 'dealerUnionState',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '共建店1',
        children: [
          {
            headerName: '品牌',
            field: 'brandName1',
            width: 15,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '经销商简称',
            field: 'shortName1',
            width: 20,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '销售代码',
            field: 'preSalesNumber1',
            width: 20,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '售后代码',
            field: 'afterSalesNumber1',
            width: 20,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '开店状态',
            field: 'dealerState1',
            width: 15,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          }
        ],
      },
      {
        headerName: '共建店2',
        children: [
          {
            headerName: '品牌',
            field: 'brandName2',
            width: 15,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '经销商简称',
            field: 'shortName2',
            width: 20,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '销售代码',
            field: 'preSalesNumber2',
            width: 20,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '售后代码',
            field: 'afterSalesNumber2',
            width: 20,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          },
          {
            headerName: '开店状态',
            field: 'dealerState2',
            width: 15,
            cellStyle: {
              textAlign: 'right',
            },
            style: {
              alignment: { vertical: 'bottom', horizontal: 'left' },
            },
          }
        ],
      }
    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '共建店信息',
        sheetName: '共建店信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '共建店信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        import: this._handleCMD,
        export: this._handleFile
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(DealerUnionManager);
